import browser from './browser'
export default browser
